<h1 mat-dialog-title><fa-icon [icon]="CommentIcon"></fa-icon> Kommentare</h1>
<mat-dialog-content>
    <app-comment-list [ViewConfig]="{order: 0,type: '',expanded: true}" [Inline]="true" [Expandable]="false" [EntityId]="entityId" [EntityType]="entityType"></app-comment-list>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button mat-dialog-close="" Color="cancel" Inverted>abbrechen</button>
</mat-dialog-actions>
